<template>
  <div class="block-logos">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BlockLogos',
  props: [],
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .block-logos
    display: flex
    flex-flow: wrap
    justify-content: center
    align-items: center
    max-width: 80rem
    margin: 0 auto 5rem auto

    div
      display: flex
      justify-content: center
      align-items: center
      width: 25rem
      height: 16.5rem

      img
        width: 7.5rem

    .bad-examples
      height: 100%
      display: flex
      flex-direction: column

      div
        position: relative

      .badUsage
        width: 120%
        height: 3px
        background-color: $primary-color
        position: absolute
        right: 0
        left: -2.4rem
        transform: rotate(33deg)

      p
        width: 22rem
        font-size: 1.4rem
        text-align: center
        margin-bottom: 2rem

</style>
